const noteTriggerSelector = '[data-t2m-cart-note-trigger]';

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest(noteTriggerSelector) : null;
  if (!trigger) return;

  const cartPage = document.querySelector('#MainContent[data-template^="cart"]');
  const note = cartPage?.querySelector('.cart-note');
  const details = note?.querySelector('details');
  const textarea = note?.querySelector('#cart-note');
  if (!(details instanceof HTMLDetailsElement) || !(textarea instanceof HTMLTextAreaElement)) return;

  details.open = true;
  textarea.focus({ preventScroll: true });
  textarea.classList.remove('t2m-cart-note--highlight');
  requestAnimationFrame(() => textarea.classList.add('t2m-cart-note--highlight'));
  window.setTimeout(() => textarea.classList.remove('t2m-cart-note--highlight'), 900);
});
